<mf-row>
  <h2>{{ title }}</h2>
</mf-row>
<ng-content></ng-content>
